<template>
    <div class="tab-swiper">
        <ul class="tabs list-unstyled">
            <li v-for="(tab, index) in tabs" :key="'tab-' + tab">
                <a
                    :href="'#' + encodeURI(tabs[index])"
                    :class="{ active: index === activeIndex }"
                    @click.prevent="onTabClick(index)"
                >
                    {{ tab }}
                </a>
            </li>
        </ul>
        <Swiper :options="swiperOptions" @load="onSwiperLoad" @slideChange="onSlideChange">
            <div
                class="swiper-slide container"
                v-for="(tab, index) in tabs"
                :key="'tab' + index"
                :data-hash="encodeURI(tab)"
            >
                <slot :name="tab"></slot>
            </div>
        </Swiper>
    </div>
</template>

<script>
/**
 * Mobile tabs with swiper
 */
export default {
    name: 'TabSwiper',
    components: {
        Swiper: () => import(/* webpackChunkName: "swiper" */ '@/components/swiper/Swiper')
    },
    data() {
        return {
            activeIndex: null,
            swiperOptions: {
                autoHeight: true,
                hashNavigation: {
                    watchState: true,
                    replaceState: true
                }
            },
            swiper: null
        };
    },
    props: {
        /**
         * @property {String[]} - tab headers
         */
        tabs: {
            type: Array,
            required: true
        }
    },
    methods: {
        onTabClick(index) {
            this.activeIndex = index;
            this.swiper.slideTo(index);
        },
        onSlideChange(swiper) {
            this.activeIndex = swiper.activeIndex;
        },
        onSwiperLoad(swiper) {
            this.activeIndex = swiper.activeIndex;
            this.swiper = swiper;
        }
    }
};
</script>

<style scoped lang="scss">
.tab-swiper {
    .tabs {
        background-color: var(--white);
        top: var(--header-mobile-height);
        display: flex;
        margin-bottom: 0;
        position: sticky;
        z-index: 3;

        > li {
            flex: 1 0 auto;

            > a {
                color: var(--body-color);
                border-bottom: 2px solid var(--border-color);
                text-transform: uppercase;
                font-size: 14px;
                font-weight: bold;
                line-height: 50px;
                height: 50px;
                width: 100%;
                display: block;
                text-align: center;
                text-decoration: none;
                transition: color 0.3s ease;

                &.active {
                    color: var(--primary);
                    border-bottom: 2px solid var(--primary);
                }
            }
        }
    }

    .tab-blocks {
        display: flex;
        width: 100%;

        ::v-deep .swiper {
            align-items: flex-start; //important!!! Tab-items should stick to top of a wrapper in order to have their own height and not stretch to swiper's height
        }

        ::v-deep .swiper-item {
            width: 100%;
            padding-right: 15px;
            padding-left: 15px;
            margin-right: auto;
            margin-left: auto;
            flex: 1 0 auto;
        }
    }
}
</style>
